<alliance-carousel *ngIf="state.carouselOptions as carouselOptions" [options]="carouselOptions" class="santa-mt-10">
  <lib-slide-template [categoryData]="CategoriesDataValuesEnum.projectStatistics">
    <p class="santa-typo-regular">{{ translations.content.statistics | translate }}</p>
  </lib-slide-template>
  <lib-slide-template [categoryData]="CategoriesDataValuesEnum.projectReport">
    <p class="santa-typo-regular">{{ translations.content.exportProjectReport | translate }}</p>
  </lib-slide-template>
  <lib-slide-template [categoryData]="CategoriesDataValuesEnum.projectStagesInfo">
    <p class="santa-typo-regular">{{ translations.content.projectFunnelInfo | translate }}</p>
  </lib-slide-template>
  <lib-slide-template [categoryData]="CategoriesDataValuesEnum.analyzeSources">
    <p class="santa-typo-regular">{{ translations.content.sourcesInfo | translate }}</p>
  </lib-slide-template>
  <lib-slide-template [categoryData]="CategoriesDataValuesEnum.recruitersActivity">
    <p class="santa-typo-regular">{{ translations.content.recruitersActivity | translate }}</p>
  </lib-slide-template>
  <lib-slide-template [categoryData]="CategoriesDataValuesEnum.projectClosures">
    <p class="santa-typo-regular">{{ translations.content.projectClosures | translate }}</p>
  </lib-slide-template>
</alliance-carousel>
